// src/utils/hash.js
export function utf16leEncode(str) {
    const buf = new Uint8Array(str.length * 2);
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        buf[i * 2] = code & 0xff;
        buf[i * 2 + 1] = code >> 8;
    }
    return buf;
}

export function hexToBytes(hex) {
    const clean = hex.replace(/^0x/i, "");
    const out = new Uint8Array(clean.length / 2);
    for (let i = 0; i < out.length; i++) out[i] = parseInt(clean.substr(i * 2, 2), 16);
    return out;
}

export function toHex(bytes) {
    return Array.from(bytes).map(b => b.toString(16).padStart(2, "0")).join("");
}

export async function sha256(bytes) {
    const digest = await crypto.subtle.digest("SHA-256", bytes);
    return new Uint8Array(digest);
}

export async function saltedHashUtf16LE(password, saltBytes) {
    debugger
    const pw = utf16leEncode(password);
    const msg = new Uint8Array(saltBytes.length + pw.length);
    msg.set(saltBytes, 0);
    msg.set(pw, saltBytes.length);
    return sha256(msg);
}
